import React, { useEffect, useRef, useState } from 'react';
import './Services.css';
import { Code, Smartphone, Palette, TrendingUp, Search, Briefcase } from 'lucide-react';

const Services = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const servicesRef = useRef(null);

  const services = [
    {
      id: 1,
      icon: <Code size={40} />,
      title: 'Website Development',
      description: 'Custom, responsive websites built with the latest technologies for optimal performance and user experience.',
    },
    {
      id: 2,
      icon: <Smartphone size={40} />,
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications that deliver seamless experiences on iOS and Android.',
    },
    {
      id: 3,
      icon: <Palette size={40} />,
      title: 'UI/UX Design',
      description: 'Beautiful, intuitive interfaces designed to engage users and enhance your brand identity.',
    },
    {
      id: 4,
      icon: <TrendingUp size={40} />,
      title: 'Digital Marketing',
      description: 'Strategic campaigns that amplify your online presence and drive measurable business growth.',
    },
    {
      id: 5,
      icon: <Search size={40} />,
      title: 'SEO Services',
      description: 'Comprehensive SEO strategies to improve your search rankings and increase organic traffic.',
    },
    {
      id: 6,
      icon: <Briefcase size={40} />,
      title: 'Branding',
      description: 'Complete brand identity solutions that tell your story and resonate with your target audience.',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardId = parseInt(entry.target.dataset.id);
            setVisibleCards((prev) => [...new Set([...prev, cardId])]);
          }
        });
      },
      { threshold: 0.2 }
    );

    const cards = document.querySelectorAll('.service-card');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="services-section" id="services" ref={servicesRef}>
      <div className="services-container">
        <div className="section-header">
          <span className="section-number">01</span>
          <h2 className="section-title">Our Services</h2>
          <p className="section-description">
            We offer comprehensive digital solutions tailored to your business needs.
            From concept to launch, we're with you every step of the way.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`service-card ${visibleCards.includes(service.id) ? 'visible' : ''}`}
              data-id={service.id}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-number">{`0${service.id}`}</div>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-hover-overlay">
                <span className="explore-text">Explore More →</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
